export default {
	data() {
		return {
			entityName: 'cron',
			moduleName: 'crons',
			detailPageRouteName: 'cronDetail',
			entity: {},
			updateFields: [
				'enabled',
				'title',
				'description',
				'expected_runtime',
				'maximum_runtime',
				'maximum_inactivity_time',
				'maximum_runs_per_day',
			],
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/crons/mixins/crons.js